<div class="digi-cert-model-container">
  <div class="loader" *ngIf="showSpinner">

<app-loading size="0.8" color="var(--primary-sec-color)" loadingSymbol="dots" >
  </app-loading>
  </div>
  <div [ngStyle]="{'opacity': showSpinner ? '0.5' : '1'}">
    <div class="create-inspection-title-container">
      <div class="title">{{title | translate}}</div>
      <div class="subtitle">{{subTitle | translate}}</div>
    </div>
    <div class="border"> </div>
    <mat-dialog-content class="override-dialog-content">
      <form #inspectionForm="ngForm">
        <div class="row dc-form-field-rapper">
          <div class="col-md-6">
            <mat-label class="dc-create-insp-form-input-label">{{'searchCustomer.firstName' | translate}}</mat-label>
            <mat-label class="mandatory dc-create-insp-form-input-label red">*</mat-label>
            <input id="firstName" [disabled]="disableInput" name="firstName" #firstName="ngModel" required
              [(ngModel)]="sigNatureObjct.firstName" matInput class="input-style m-t-xs"
              [ngClass]="{'disabled-inputColor':disableInput}" type="text" />
            <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="alert">
              <mat-label *ngIf="firstName.errors?.required" class="digicert-warning-error-message">
                {{'searchCustomer.firstNameIsRequired' | translate}}</mat-label>
            </div>
          </div>
          <div class="col-md-6">
            <mat-label class="dc-create-insp-form-input-label">{{'searchCustomer.lastName' | translate}}</mat-label>
            <mat-label class="dc-create-insp-form-input-label fontSize red">*</mat-label>
            <input id="lastName" [disabled]="disableInput" name="lastName" #lastName="ngModel" required matInput
              class="input-style m-t-xs form-control" [ngClass]="{'disabled-inputColor':disableInput}" type="text"
              [(ngModel)]="sigNatureObjct.lastName" />
  
            <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" style="color: red;">
              <mat-label *ngIf="lastName.errors?.required" style="color: red;">
                {{'searchCustomer.lastNameIsRequired' | translate}}</mat-label>
            </div>
          </div>
        </div>
        <div class="row dc-form-field-rapper">
          <div class="col-md-12" *ngIf="sigNatureObjct.type === 'TECHNICIAN'">
            <mat-checkbox class="padding-checkbox" name="isSignatureCreated" [(ngModel)]="signatureInfo.isLoggedIn"
              (change)="onChangeCheckbox($event)"> </mat-checkbox>
            <mat-label class="dc-create-insp-form-input-label">{{'deliveryChecklist.useStoredElectronicSignature' | translate}}</mat-label>
          </div>
        </div>
        <div class="signature-icon">
        </div>
        <div class="signature-pad">
          <div class="signature-pad-body">
            <div class="row">
              <div class="col-sm-9 justify-content-end">
                <button class="clearIcon" [hidden]="disableClearIcon" (click)="clearSigPad()"> {{'deliveryChecklist.clear' | translate}}</button>
              </div>
            </div>
            <canvas (mouseleave)="signaturePadCanvas()" [hidden]="disableSignaturePad" #sPad width="430" height="90"
              style="touch-action: none;" (click)="signaturePadCanvas()"></canvas>
            <img class="blank-img" [hidden]="disableElectronicSignature" [src]="sigNatureObjct.data" alt="signature">
  
          </div>
        </div>
  
        <div class="row dc-form-field-rapper">
          <div class="col-md-12">
            <mat-checkbox class="padding-checkbox" name="isSignatureCertified" required [(ngModel)]="sigNatureObjct.isSignatureCertified" value="1"
              (change)="certify($event)"> </mat-checkbox>
            <mat-label class="dc-create-insp-form-input-certify-box-label">{{certifyText | translate}}
            </mat-label>
          </div>
        </div>
      </form>
  
    </mat-dialog-content>
    <div class="border"> </div>
    <mat-dialog-actions align="end">
      <button mat-button id="cancelBtn" class="secondary-button" (click)="clear()" mat-dialog-close>{{'deliveryChecklist.cancel' | translate}}</button>
      <button id="saveButton" mat-button type="submit" [disabled]="inspectionForm.invalid || disableSaveAndSubmit"
        class="primary-button" (click)="saveSignature()">{{'deliveryChecklist.save' | translate}}</button>
    </mat-dialog-actions>
  </div>
  </div>
  